import { createElement } from 'react';
import classNames from 'classnames';
import './index.scss';
const ColorfulDivider = props => {
    const { contentPosition = 'center', direction = 'horizontal', children } = props;
    const classPrefix = `au-divider`;
    return (createElement("div", { className: classNames(classPrefix, `${classPrefix}-${direction}`, `${classPrefix}-${contentPosition}`) }));
};
ColorfulDivider.displayName = 'ColorfulDivider';
export default ColorfulDivider;
